import {ReactElement} from 'react';
import {Link} from '@shopify/hydrogen';
import {EventDetailType} from '../../types';
import {formatPublishedAtDate} from '../../utils';
import ImageContainer from '../ImageContainer.client';
import {EventPlaceholderDesktopPNG} from '../../assets/img/index';

interface EventRecommendedListProps {
  events: ReadonlyArray<EventDetailType>;
}

export default function EventRecommendedList({
  events,
}: EventRecommendedListProps): ReactElement {
  return (
    <div className="past-virtual-events list-type-2 image-hover">
      <div className="container">
        <div className="products__top filters__top">
          <h4 className="title-1">
            Other events you might be interested in...
          </h4>
          <div className="products__top-right filters__top-right">
            <Link to="/events/" className="button button_has_icon button-arrow">
              View all
            </Link>
          </div>
        </div>
        <div className="past-virtual-events-list list-type-2__list">
          {events.map(
            ({uuid, slug, event_images, event_types, starts_at, title}) => (
              <Link
                key={uuid}
                to={`/events/${slug}/`}
                className="past-virtual-events-item list-type-2__item"
              >
                <div className="past-virtual-events-image list-type-2__image">
                  <ImageContainer
                    jpegSrc={
                      event_images[0]?.image_desktop_jpeg ||
                      EventPlaceholderDesktopPNG
                    }
                    webpSrc={event_images[0]?.image_desktop_webp}
                    widthInPx={800}
                    heightInPx={800}
                    alt={title}
                  />
                </div>
                {event_types.map((eventType) => (
                  <div key={eventType} className="event-label tag-element">
                    {eventType}
                  </div>
                ))}
                <div className="event-date date-element">
                  {formatPublishedAtDate(starts_at)}
                </div>
                <h4 className="event-title title-item">{title}</h4>
              </Link>
            ),
          )}
        </div>
      </div>
    </div>
  );
}
